
import { Component, Vue, Prop } from "vue-property-decorator";
import { map, orderBy, reduce } from "lodash";
import { LeaderBoard } from "@/models/LeaderBoard";
import { LeaderBoardTeams } from "@/models/LeaderBoardTeams";
import { DateTime, Duration } from "luxon";

@Component
class GameStats extends Vue {
  @Prop({ default: "" }) readonly leaderBoardArray!: LeaderBoard[];
  fastestVerifiedTimeKey = {} as LeaderBoard;
  highestWinRatioKey = {} as LeaderBoard;
  highestWinRatioKeyTitle = "";
  fastestVerifiedTimeKeyTitle = "";

  get getGameName(): string {
    return "Game Type: " + this.leaderBoardArray[0].meta.season.gt_dname.en;
  }

  get getGamesSelected(): number {
    return this.leaderBoardArray.length;
  }

  get teamSuccessPercentage(): string {
    var highestRatio = 0;
    var cityName = "";
    this.leaderBoardArray.forEach((value: LeaderBoard) => {
      if (value.team_stats !== undefined) {
        const successPer =
          (reduce(
            value.team_stats,
            (memo: number, leader: LeaderBoardTeams) => {
              if (leader.game_status === "win") {
                return memo + 1;
              }
              return memo;
            },
            0
          ) /
            Object.keys(value.team_stats).length) *
          100;

        if (successPer > highestRatio) {
          highestRatio = successPer;
          cityName = value.meta.city_dname.en;
          this.highestWinRatioKey = value;
          this.highestWinRatioKeyTitle = value.meta.admin_name;
        }
      }
    });
    return highestRatio.toFixed(2) + "% | " + "[" + cityName + "]";
  }

  get getFastestVerified(): string {
    let fastest = Number.MAX_VALUE;
    let cityName = "";
    let teamName = "";
    let startDate = "";
    this.leaderBoardArray.forEach((value) => {
      if (value.team_stats !== undefined) {
        const results = orderBy(
          map(value.team_stats, function(x: LeaderBoardTeams) {
            if (x.verified && x.game_status === "win") return x;
          }),
          ["game_status", "timer.comp_dur_s"],
          ["asc", "asc"]
        );
        if (results[0] !== undefined) {
          const time = results[0].timer?.comp_dur_s;
          if (time !== undefined || time === null) {
            if (time < fastest) {
              fastest = time;
              cityName = value.meta.city_dname.en;
              teamName = results[0].team_dname;
              this.fastestVerifiedTimeKey = value;
              this.fastestVerifiedTimeKeyTitle = value.meta.admin_name;
              startDate = DateTime.fromISO(value.meta.start_dt).toFormat(
                "dd/MM/yyyy"
              );
            }
          }
        }
      }
    });
    if (fastest == Number.MAX_VALUE) {
      return "N/A";
    }
    return (
      Duration.fromObject({ seconds: fastest }).toFormat("hh:mm:ss") +
      " | [" +
      cityName +
      " ( " +
      startDate +
      ") & " +
      teamName +
      "]"
    );
  }

  openLeaderBoard(leaderBoard: LeaderBoard, leaderBoardTitle: string): void {
    const value = {
      leaderBoard: leaderBoard,
      leaderBoardTitle: leaderBoardTitle,
    };
    this.$emit("openLeaderBoard", value);
  }
}

export default GameStats;
